import { render, staticRenderFns } from "./Pflichtproben.vue?vue&type=template&id=162e4af0&"
import script from "./Pflichtproben.vue?vue&type=script&lang=js&"
export * from "./Pflichtproben.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports